import Invoices from './Invoices';

/**
 * SentInvoices — thin wrapper that renders the Invoices page in
 * "sent" mode. Lives at /invoices/sent and shows the detailed
 * RM-grouped, plant-bucketed view of every previously-issued invoice.
 * The actual list is implemented inside Invoices.jsx; this file
 * exists so App.jsx routes have a clean per-tab component to point at.
 */
export default function SentInvoices() {
  return <Invoices view="sent" />;
}
